import { ColDef } from 'ag-grid-community';

export const PurchaseHistoryColumnDef: ColDef[] = [
  { // Purchase Date
    headerName: 'Purchase Date',
    field: 'purchase_date',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  { // Vendor Name
    headerName: 'Vendor Name',
    field: 'vendor_name',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
  },
  { // Item UPC
    headerName: 'Item UPC',
    field: 'item_upc',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  { // Item Name
    headerName: 'Item Name',
    field: 'item_name',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  { // Item Description
    headerName: 'Item Description',
    field: 'item_description',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
  },
  { // Desired Quantity
    headerName: 'Desired Quantity',
    field: 'desired_qty',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
  },
  { // Purchase Quantity
    headerName: 'Purchase Quantity',
    field: 'purchase_qty',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
  },
  { // Item Price
    headerName: 'Item Price',
    field: 'item_price',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    valueFormatter: currencyFormatter,
  },
  { // Purchase Total
    headerName: 'Purchase Total',
    field: 'purchase_total',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    valueFormatter: currencyFormatter,
  },
  { // Order Number
    headerName: 'Order Number',
    field: 'order_number',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
  },
];

function currencyFormatter(params: any) {
  return '$' + params.value.toFixed(2);
}